import { render, staticRenderFns } from "./wenWanJie.vue?vue&type=template&id=8e70070a&scoped=true"
import script from "./wenWanJie.vue?vue&type=script&lang=js"
export * from "./wenWanJie.vue?vue&type=script&lang=js"
import style0 from "./wenWanJie.vue?vue&type=style&index=0&id=8e70070a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e70070a",
  null
  
)

export default component.exports